var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-row mb-2"},[_c('div',{staticClass:"vx-col w-full"},[_c('vs-upload',{attrs:{"automatic":"","name":"file","fileName":"file","text":"Upload","action":_vm.uploadUrl},on:{"on-success":_vm.successUpload}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }